<template>
    <page-container2 title="产品管理" showRefreshBtn @refresh="$refs.pageTable.load()">
        <template v-slot:buttons>
            <permission-container permissionId="Erp.Product.Add">
                <el-button type="primary" size="mini" @click="add" >添加</el-button>
            </permission-container>
        </template>
        <pagination-table ref="pageTable" :tableList="tableList" showCloseBtn tablePermissionId="Erp.Product.List">
            <template v-slot:tableColumns>
                <el-table-column
                    type="index"
                    label="序号"
                    width="150"
                    align="center"
                    >
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="产品名称">
                </el-table-column>
                <el-table-column
                    prop="code"
                    label="产品编码">
                </el-table-column>
                <el-table-column
                    prop="remark"
                    label="备注">
                </el-table-column>
                <el-table-column
                    prop="updateTime"
                    label="更新时间"
                    width="180">
                    <template slot-scope="scope">
                        <date-time-render :value="scope.row.updateTime"/>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="150"
                    >
                    <template slot-scope="scope">
                        <permission-container permissionId="Erp.Product.Edit">
                            <el-button
                            size="mini"
                            @click="edit(scope.row, scope.$index)">编辑</el-button>
                        </permission-container>
                        <permission-container permissionId="Erp.Product.Delete">
                            <el-button
                            size="mini"
                            type="danger"
                            @click="deleteProduct(scope.row, scope.$index)">删除</el-button>
                        </permission-container>
                        
                    </template>
                </el-table-column>
            </template>
        </pagination-table>
    </page-container2>
</template>

<script>
import List from "@/components/table/List";

export default
{
    name: "ProductList",
    data()
    {
        return {
            tableList: new List({url: '/product/list'}),
        }
    },
    created()
    {
        console.log('list created');
    },
    mounted()
    {
    },
    methods:
    {
        add()
        {
            let bridge = this.dispatchRouteTo('/erp/product/edit');
            bridge.onRouteBack = ()=>
            {
                this.tableList.load();
            }
        },
        edit(rowData, index)
        {
            console.log(rowData, index);
            let bridge = this.dispatchRouteTo('/erp/product/edit', {id: rowData.id});
            bridge.onRouteBack = ()=>
            {
                this.tableList.load();
            }
        },
        deleteProduct(rowData, index)
        {
            console.log(rowData, index);
            return this.showConfirm("确定要删除吗？").
            then((result)=>{
                if(!result) return;
                return Fx.Http.post("/product/delete", {id: rowData.id}).
                then((resp)=>
                {
                    if(resp.isSuccess()) {
                        this.showMessageSuccess('删除成功', ()=>
                        {
                            this.tableList.load();
                        })
                    } else {
                        this.showMessageError(resp.getErrorMessage());
                    }
                })
            })
        },
    }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/modules/erp/pages/product/List.vue